import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

function functionFormatPrice(value) {
    let val = (value / 1).toFixed(2);
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function FormatoFechaConHora(value) {
    const fecha = new Date(value);
    return format(fecha, "dd-MMMM-yyyy HH:mm:ss", { locale: es }).toUpperCase();
}

function calcularAnchoProporcional(base64, alturaFija) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            const ancho = img.naturalWidth && img.naturalHeight
                ? (img.naturalWidth * alturaFija) / img.naturalHeight
                : 50;
            resolve(ancho);
        };
        img.onerror = () => resolve(50);
        img.src = base64;
    });
}

function detectarFormatoImagen(base64) {
    if (base64.startsWith('data:image/png'))  return 'PNG';
    if (base64.startsWith('data:image/jpeg')) return 'JPEG';
    if (base64.startsWith('data:image/jpg'))  return 'JPEG';
    if (base64.startsWith('data:image/gif'))  return 'GIF';
    if (base64.startsWith('data:image/webp')) return 'WEBP';
    return 'PNG';
}

const AjusteAnualPDF = async (
    itemsReporteDeudas, itemsReporteCreditos,
    objEmpresa,
    sumaCreditos, sumaDeudas, mesesEjercicio,
    inpcAntiguo, inpcReciente,
    factAjusteAnualIA, factAjusteAnual, diferencia,
    promedioAnualCreditos, promedioAnualDeudas, Name
) => {
    return new Promise(async (resolve, reject) => {
        try {
            const doc = new jsPDF({ format: 'letter', orientation: 'landscape' });
            const color               = objEmpresa?.color || '#662e91';
            const logoBase64          = objEmpresa?.logo?.base64 || '';
            const fechaHoraGeneracion = FormatoFechaConHora(new Date());

            const pageW  = doc.internal.pageSize.getWidth();
            const pageH  = doc.internal.pageSize.getHeight();
            const margen = 10;
            const xDer   = pageW - margen;

            // ── Cabecera reutilizable ─────────────────────────────────────
            const dibujarCabecera = async () => {
                let y = 14;

                if (logoBase64 !== '') {
                    const alturaLogo = 25;
                    const formatoImg = detectarFormatoImagen(logoBase64);
                    const anchoLogo  = await calcularAnchoProporcional(logoBase64, alturaLogo);
                    doc.addImage(logoBase64, formatoImg, margen, y - 5, anchoLogo, alturaLogo);
                }

                doc.setFontSize(14);
                doc.setFont('helvetica', 'bold');
                doc.setTextColor('#000000');
                doc.text('Ajuste Anual por Inflación', xDer, y, { align: 'right' });

                doc.setFontSize(10);
                doc.setFont('helvetica', 'normal');
                doc.text(
                    (objEmpresa?.rfc || '') + ' | ' + (objEmpresa?.empresa || objEmpresa?.nombre || ''),
                    xDer, y += 5, { align: 'right' }
                );
                doc.text('PERIODO: ' + Name, xDer, y += 5, { align: 'right' });

                return y + 10; // y de inicio para el contenido
            };

            // ─────────────────────────────────────────────────────────────
            // PÁGINA 1 — Acumulables + tabla Créditos
            // ─────────────────────────────────────────────────────────────
            let y = await dibujarCabecera() + 5;

            // Título sección
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(color);
            doc.text('Acumulables', margen, y);
            doc.setDrawColor(color);
            doc.setLineWidth(0.5);
            doc.line(margen, y + 1, xDer, y + 1);
            y += 6;
            doc.setTextColor('#000000');

            // ── Bloque de resumen (igual que el original: 4 columnas) ─────
            doc.setFontSize(11);
            doc.setFont('helvetica', 'bold');
            doc.text('TOTALES',                  margen,        y);
            doc.text('SALDOS',                   margen + 65,   y);
            doc.text('FACTOR DE AJUSTE ANUAL',   margen + 155,  y);
            doc.text("INPC's",                   margen + 220,  y);

            y += 5;
            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');

            // Totales
            doc.text('• Total Créditos:',        margen,      y);
            doc.text('• Total Deudas:',           margen,      y + 5);
            doc.text('• Meses del Ejercicio:',    margen,      y + 10);
            doc.text(functionFormatPrice(sumaCreditos),  margen + 58, y,      { align: 'right' });
            doc.text(functionFormatPrice(sumaDeudas),    margen + 58, y + 5,  { align: 'right' });
            doc.text(String(mesesEjercicio),             margen + 58, y + 10, { align: 'right' });

            // Saldos
            doc.text('• Saldo promedio anual de deudas:',    margen + 65, y);
            doc.text('• Saldo promedio anual de créditos:',  margen + 65, y + 5);
            doc.text('• Diferencia:',                        margen + 65, y + 10);
            doc.text(functionFormatPrice(promedioAnualDeudas),    margen + 146, y,      { align: 'right' });
            doc.text(functionFormatPrice(promedioAnualCreditos),  margen + 146, y + 5,  { align: 'right' });
            doc.text(functionFormatPrice(diferencia),             margen + 146, y + 10, { align: 'right' });

            // Factor de ajuste anual
            const resp = diferencia * factAjusteAnual;
            doc.text('• Factor de Ajuste Anual:', margen + 155, y);
            doc.text(
                resp < 0
                    ? '• Ajuste Anual por\n  Inflación Deducible:'
                    : '• Ajuste Anual por\n  Inflación Acumulable:',
                margen + 155, y + 5
            );
            doc.text(factAjusteAnual.toFixed(4), margen + 217, y,      { align: 'right' });
            doc.text('\n' + factAjusteAnualIA,   margen + 217, y + 5,  { align: 'right' });

            // INPCs
            doc.text('• INPC Reciente:', margen + 220, y);
            doc.text('• INPC Antiguo:',  margen + 220, y + 5);
            doc.text(inpcReciente.toFixed(3), xDer, y,     { align: 'right' });
            doc.text(inpcAntiguo.toFixed(3),  xDer, y + 5, { align: 'right' });

            y += 20;

            // Título tabla Créditos
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(color);
            doc.text('Créditos', margen, y);
            doc.setDrawColor(color);
            doc.line(margen, y + 1, xDer, y + 1);
            y += 4;
            doc.setTextColor('#000000');

            // Tabla Créditos
            const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
                           'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre','Suma'];

            doc.autoTable({
                startY: y,
                head: [['Mes','Bancos','Inversiones','Otros Instr. Fin.',
                        'Clientes','Ctas. y Docs. por Cobrar',
                        'Partes Rel. Nac.','Partes Rel. Ext.',
                        'Otros Deudores Div.','Suma']],
                body: meses.map((mes, i) => {
                    const d = itemsReporteCreditos[i];
                    return [
                        mes,
                        functionFormatPrice(d.bancos),
                        functionFormatPrice(d.inversiones),
                        functionFormatPrice(d.otrosInstrumentosFinancieros),
                        functionFormatPrice(d.clientes),
                        functionFormatPrice(d.cuentasYDocumentosPorCobrar),
                        functionFormatPrice(d.partesRelacionadasNacionales),
                        functionFormatPrice(d.partesRelacionadasExtranjeros),
                        functionFormatPrice(d.otrosDeudoresDiversos),
                        functionFormatPrice(d.suma),
                    ];
                }),
                styles: { fontSize: 7, cellPadding: 2 },
                headStyles: { fillColor: color, textColor: '#ffffff', fontStyle: 'bold', halign: 'center' },
                alternateRowStyles: { fillColor: '#f4f4f4' },
                columnStyles: {
                    0: { halign: 'left'  },
                    1: { halign: 'right' }, 2: { halign: 'right' },
                    3: { halign: 'right' }, 4: { halign: 'right' },
                    5: { halign: 'right' }, 6: { halign: 'right' },
                    7: { halign: 'right' }, 8: { halign: 'right' },
                    9: { halign: 'right', fillColor: '#eeeeee' },
                },
                margin: { left: margen, right: margen },
            });

            // ─────────────────────────────────────────────────────────────
            // PÁGINA 2 — tabla Deudas + leyenda
            // ─────────────────────────────────────────────────────────────
            doc.addPage();
            await dibujarCabecera();

            // Título tabla Deudas
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(color);
            doc.text('Deudas', margen, 33);
            doc.setDrawColor(color);
            doc.line(margen, 34, xDer, 34);
            doc.setTextColor('#000000');

            doc.autoTable({
                startY: 37,
                head: [['Mes','1*','2*','3*','4*','5*','6*','7*','8*','9*',
                        '10*','11*','12*','13*','14*','15*','16*','17*','18*','Suma']],
                body: meses.map((mes, i) => {
                    const d = itemsReporteDeudas[i];
                    return [
                        mes,
                        functionFormatPrice(d.proveedores),
                        functionFormatPrice(d.cuentasPorPagarACortoPlazo),
                        functionFormatPrice(d.instrumentosFinancierosCortoP),
                        functionFormatPrice(d.acreedoresDiversosCortoPlazoN),
                        functionFormatPrice(d.acreedoresDiversosCortoPlazoE),
                        functionFormatPrice(d.acreedoresDiversosCortoPlazoNPR),
                        functionFormatPrice(d.acreedoresDiversosCortoPlazoEPR),
                        functionFormatPrice(d.otrosAcreedoresDiversosCortoP),
                        functionFormatPrice(d.otrosPasivosCortoPlazo),
                        functionFormatPrice(d.acreedoresDivLargoPlazoN),
                        functionFormatPrice(d.acreedoresDivLargoPlazoE),
                        functionFormatPrice(d.acreedoresDivLargoPlazoNPR),
                        functionFormatPrice(d.acreedoresDivLargoPlazoEPR),
                        functionFormatPrice(d.otrosAcreedoresDiversosLargoPlazo),
                        functionFormatPrice(d.cuentasPorPagarLargoPlazo),
                        functionFormatPrice(d.instrumentosFinancierosLargoP),
                        functionFormatPrice(d.otrosPasivosLargoPlazo),
                        functionFormatPrice(d.aportacionesFuturoAumentoCapital),
                        functionFormatPrice(d.suma),
                    ];
                }),
                styles: { fontSize: 6, cellPadding: 1.5 },
                headStyles: { fillColor: color, textColor: '#ffffff', fontStyle: 'bold', halign: 'center' },
                alternateRowStyles: { fillColor: '#f4f4f4' },
                columnStyles: {
                    0:  { halign: 'left'  },
                    1:  { halign: 'right' }, 2:  { halign: 'right' },
                    3:  { halign: 'right' }, 4:  { halign: 'right' },
                    5:  { halign: 'right' }, 6:  { halign: 'right' },
                    7:  { halign: 'right' }, 8:  { halign: 'right' },
                    9:  { halign: 'right' }, 10: { halign: 'right' },
                    11: { halign: 'right' }, 12: { halign: 'right' },
                    13: { halign: 'right' }, 14: { halign: 'right' },
                    15: { halign: 'right' }, 16: { halign: 'right' },
                    17: { halign: 'right' }, 18: { halign: 'right' },
                    19: { halign: 'right', fillColor: '#eeeeee' },
                },
                margin: { left: margen, right: margen },
            });

            // Leyenda en 3 columnas (igual posicionamiento que el original)
            const leyenda = [
                '*1 Proveedores',
                '*2 Cuentas por Pagar a Corto Plazo',
                '*3 Instrumentos Financieros Corto Plazo',
                '*4 Acreedores Diversos Corto Plazo Nacionales',
                '*5 Acreedores Diversos Corto Plazo Extranjeros',
                '*6 Acreedores Diversos Corto Plazo Nacional Parte Relacionada',
                '*7 Acreedores Diversos Corto Plazo Extranjero Parte Relacionada',
                '*8 Otros Acreedores Diversos Corto Plazo',
                '*9 Otros Pasivos Corto Plazo',
                '*10 Acreedores Diversos Largo Plazo Nacional',
                '*11 Acreedores Diversos Largo Plazo Extranjero',
                '*12 Acreedores Diversos Largo Plazo Nacional Parte Relacionada',
                '*13 Acreedores Diversos Largo Plazo Extranjero Parte Relacionada',
                '*14 Otros Acreedores Diversos Largo Plazo',
                '*15 Cuentas por Pagar Largo Plazo',
                '*16 Instrumentos Financieros Largo Plazo',
                '*17 Otros Pasivos Largo Plazo',
                '*18 Aportaciones para Futuro Aumento de Capital',
            ];

            const spacing = 4;
            const colOffset = [0, 90, 180];
            doc.setFontSize(8);
            doc.setFont('helvetica', 'italic');
            doc.setTextColor('#888888');

            leyenda.forEach((txt, i) => {
                const col = Math.floor(i / 7);
                const row = i % 7;
                const xL  = margen + (colOffset[col] || 0);
                const yL  = pageH - 20 - (spacing * (6 - row));
                doc.text(txt, xL, yL);
            });

            // ── Pie de página ─────────────────────────────────────────────
            const totalPages = doc.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
                doc.setFont('helvetica', 'italic');
                doc.setFontSize(8);
                doc.setTextColor(150);
                doc.setDrawColor(color);
                doc.setLineWidth(0.3);
                doc.line(margen, pageH - 16, xDer, pageH - 16);
                doc.text('Generado: ' + fechaHoraGeneracion, margen, pageH - 8, { align: 'left' });
                doc.text('Documento generado por ContaGo', pageW / 2, pageH - 8, { align: 'center' });
                doc.text('Página ' + i + ' de ' + totalPages, xDer, pageH - 8, { align: 'right' });
            }

            const base64 = doc.output('datauristring');
            resolve(base64);
        } catch (error) {
            console.error(error);
            reject(error);
        }
    });
};

export { AjusteAnualPDF };